import { Component, Input, OnInit } from '@angular/core';
import { VentaService } from 'src/app/services/venta.service';
import * as moment from 'moment';


@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styles: [
  ]
})
export class FooterComponent implements OnInit {

  tiempo: string;
  @Input('texto') texto: string;

  constructor(public service: VentaService) { }

  ngOnInit(): void {

    const apertura = moment(this.service.caja.apertura);
    const tiempox = moment.duration(moment().diff(apertura));
    this.tiempo = `${tiempox.hours()}H ${tiempox.minutes()}M`;

  }

}
